module.exports = __webpack_public_path__ + "static/gaspar-81c0ed22d5d760aa39f6fee430d148ec.png";